import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=0dc53b88"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"
import style0 from "./Members.vue?vue&type=style&index=0&id=0dc53b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports